import { render, staticRenderFns } from "./AdditionalInfoBottom.vue?vue&type=template&id=680d7361&scoped=true&"
import script from "./AdditionalInfoBottom.vue?vue&type=script&lang=js&"
export * from "./AdditionalInfoBottom.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalInfoBottom.vue?vue&type=style&index=0&id=680d7361&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680d7361",
  null
  
)

export default component.exports